import React from 'react';
import { useParams } from 'react-router-dom';
import Account from 'src/components/Account/Account';
import { SelfServiceCorporateDataProvider } from 'src/components/selfService/common/SelfServiceCorporateData/SelfServiceCorporateDataProvider';

export default function AccountWrapper(): JSX.Element {
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <SelfServiceCorporateDataProvider corpId={corpId}>
      <Account />
    </SelfServiceCorporateDataProvider>
  );
}
